<template>
  <VExpansionPanels>
    <VExpansionPanel
      v-for="(item, index) in faq"
      :key="item.id"
      class="transparent elevation-1 px-4 py-1"
    >
      <VExpansionPanelHeader class="subtitle-2 d-flex justify-start align-start">
        <div class="num">
          {{ index+1 }}.
        </div>
        <div class="txt mr-auto">
          {{ item.question }}
        </div>
      </VExpansionPanelHeader>
      <VExpansionPanelContent>
        <div
          class="subtitle-2 font-regular grey--text d-flex justify-start align-start"
        >
          <div class="num" />
          <div class="txt mr-auto">
            {{ item.answer }}
          </div>
        </div>
      </VExpansionPanelContent>
    </VExpansionPanel>
  </VExpansionPanels>
</template>

<script>
export default {
  name: 'VacancyFaq',
  props: {
    faq: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.num {
  width: 20px;
  flex-shrink: 0;
}

.txt {
  width: calc(100% - 44px);
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

::v-deep .v-expansion-panels {
  max-width: 100%;
  overflow-x: hidden;
}

::v-deep .v-expansion-panel {
  max-width: 100%;
  overflow-x: hidden;
}
</style>
